import {IBusiness} from 'app/modules/discovery/core'
import {JsonObject} from 'utilities/types'
import {CGraphEntity} from './graph_entity'
import {CNote} from './note'

export class CBusiness extends CGraphEntity<IBusiness> implements IBusiness {
  static children = {
    notes: CNote,
  }

  standard_name
  standard_web_domain
  website
  summary
  description
  city
  state_province
  country
  crunchbase_permalink
  crunchbase_active
  estimated_revenue_category
  total_funding_original
  total_funding_original_currency
  total_funding_usd
  acquired_by
  acquired_by_website
  industries
  similar_company_count
  sam_identifier
  sam_last_updated
  sam_registration_date
  cage_code
  naics_codes
  psc_codes
  address_line_1
  address_line_2
  address_city
  address_state_province
  address_country
  address_postal_code
  mailing_address_line_1
  mailing_address_line_2
  mailing_address_city
  mailing_address_state_province
  mailing_address_country
  mailing_address_postal_code
  congressional_district
  point_of_contact_name_first
  point_of_contact_name_mi
  point_of_contact_name_last
  point_of_contact_address_line_1
  point_of_contact_address_line_2
  point_of_contact_city
  point_of_contact_state_province
  point_of_contact_address_country
  point_of_contact_address_postal_code
  business_structure
  business_types
  total_revenue
  agency_breakdown
  naics_breakdown
  annual_revenues
  awards_count
  awards_amount
  awards_by_year
  email_addresses
  logo
  twitter_page
  linkedin_page
  facebook_page

  constructor(data: IBusiness & JsonObject) {
    super('Business', data)
    this.standard_name = data.standard_name
    this.standard_web_domain = data.standard_web_domain
    this.website = data.website
    this.summary = data.summary
    this.description = data.description
    this.city = data.city
    this.state_province = data.state_province
    this.country = data.country
    this.crunchbase_permalink = data.crunchbase_permalink
    this.crunchbase_active = data.crunchbase_active
    this.estimated_revenue_category = data.estimated_revenue_category
    this.total_funding_original = data.total_funding_original
    this.total_funding_original_currency = data.total_funding_original_currency
    this.total_funding_usd = data.total_funding_usd
    this.acquired_by = data.acquired_by
    this.acquired_by_website = data.acquired_by_website
    this.industries = data.industries
    this.similar_company_count = data.similar_company_count
    this.sam_identifier = data.sam_identifier
    this.sam_last_updated = data.sam_last_updated
    this.sam_registration_date = data.sam_registration_date
    this.cage_code = data.cage_code
    this.naics_codes = data.naics_codes
    this.psc_codes = data.psc_codes
    this.address_line_1 = data.address_line_1
    this.address_line_2 = data.address_line_2
    this.address_city = data.address_city
    this.address_state_province = data.address_state_province
    this.address_country = data.address_country
    this.address_postal_code = data.address_postal_code
    this.mailing_address_line_1 = data.mailing_address_line_1
    this.mailing_address_line_2 = data.mailing_address_line_2
    this.mailing_address_city = data.mailing_address_city
    this.mailing_address_state_province = data.mailing_address_state_province
    this.mailing_address_country = data.mailing_address_country
    this.mailing_address_postal_code = data.mailing_address_postal_code
    this.congressional_district = data.congressional_district
    this.point_of_contact_name_first = data.point_of_contact_name_first
    this.point_of_contact_name_mi = data.point_of_contact_name_mi
    this.point_of_contact_name_last = data.point_of_contact_name_last
    this.point_of_contact_address_line_1 = data.point_of_contact_address_line_1
    this.point_of_contact_address_line_2 = data.point_of_contact_address_line_2
    this.point_of_contact_city = data.point_of_contact_city
    this.point_of_contact_state_province = data.point_of_contact_state_province
    this.point_of_contact_address_country = data.point_of_contact_address_country
    this.point_of_contact_address_postal_code = data.point_of_contact_address_postal_code
    this.business_structure = data.business_structure
    this.business_types = data.business_types
    this.total_revenue = data.total_revenue
    this.agency_breakdown = data.agency_breakdown
    this.naics_breakdown = data.naics_breakdown
    this.annual_revenues = data.annual_revenues
    this.awards_count = data.awards_count
    this.awards_amount = data.awards_amount
    this.awards_by_year = data.awards_by_year
    this.email_addresses = data.email_addresses
    this.logo = data.logo
    this.twitter_page = data.twitter_page
    this.linkedin_page = data.linkedin_page
    this.facebook_page = data.facebook_page
  }

  stringify() {
    return JSON.stringify(this.export())
  }

  export() {
    return {id: this.id}
  }

  get website_with_protocol() {
    if (!this.website) {
      return null
    }
    if (this.website.substring(0, 4).toLowerCase() === 'http') {
      return this.website
    }
    return `http://${this.website}`
  }
}
